/*!
 * Solva — AJAX add-to-cart for the migraine PDP hero & pricing-anchor forms.
 * Posts to /cart/add.js so the UpCart drawer app detects the add and opens.
 */
(function () {
  if (typeof document === 'undefined') return;
  if (window.__solvaCartReady) return;   // guard against double inclusion
  window.__solvaCartReady = true;

  var SELECTOR = '.solva-pdpx__form, .solva-pa__form, .solva-stickybar__form';

  function addToCart(form) {
    var btn = form.querySelector('[name="add"]');
    if (btn) {
      if (btn.dataset.solvaLoading === '1') return; // block double submit
      btn.dataset.solvaLoading = '1';
      btn.dataset.solvaLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Adding…';
    }

    function restore() {
      if (!btn) return;
      btn.disabled = false;
      delete btn.dataset.solvaLoading;
      if (btn.dataset.solvaLabel != null) {
        btn.innerHTML = btn.dataset.solvaLabel;
        delete btn.dataset.solvaLabel;
      }
    }

    fetch('/cart/add.js?upcart=1', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        restore();
        if (!r.ok) { form.submit(); return; } // validation error -> native fallback
        // UpCart patches fetch and auto-opens on /cart/add.js. Dispatch the
        // common cart events too as a backstop for other drawer apps.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: r.data }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        restore();
        form.submit(); // network failure -> native submit
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  // Smooth in-page scroll for CTAs that point at an on-page anchor (#atc, #faq...).
  // Guarantees the non-drawer CTAs land on their target regardless of theme quirks.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var hash = href.charAt(0) === '#' ? href : (href.indexOf('#') > -1 ? '#' + href.split('#')[1] : '');
    if (!hash || hash === '#') return;
    var target;
    try { target = document.querySelector(hash); } catch (err) { return; }
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', hash);
  });
})();
